import React, { useEffect, useState } from 'react';
import Typography from '../../components/common/Typography';
import SpacingContainerBase from '../../components/layouts/SpacingContainerBase';
import { useTrans } from '../../services/i18n';
import connect from './connect';

import TabPanel from './TabPanel';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import styles from './styles.module.css';
import clsx from 'clsx';
import { Grid } from '@material-ui/core';

//Tabs
import BillingTab from './BillingTab';
import InvoicesTab from './InvoicesTab';

import { useHistory, useLocation } from 'react-router-dom';
import { ROUTE_PLANS_PRIVATE } from '../../constants';

const TAB_BILLING = 'billing';
const TAB_INVOICES = 'invoices';
const TAB_PLAN = 'plan';

const Billing = (props) => {
  const { getInvoices } = props;
  const { trans } = useTrans();
  const history = useHistory();
  const search = useLocation().search;

  const [activeTab, setActiveTab] = useState(TAB_BILLING);
  const [hasInvoices, setHasInvoices] = useState(false);

  const handleChange = (event, newValue) => {
    if (newValue === TAB_PLAN) {
      history.push(ROUTE_PLANS_PRIVATE.path);
      return;
    }
    setActiveTab(newValue);
  };

  const a11yProps = (key) => {
    return {
      id: `simple-tab-${key}`,
      'aria-controls': `simple-tabpanel-${key}`,
    };
  };

  useEffect(() => {
    // Presence probe: no year/month → backend returns latest invoices unscoped by date.
    let active = true;
    getInvoices({}).then((res) => {
      if (!active) return;
      setHasInvoices((res?.payload?.invoices ?? []).length > 0);
    });
    return () => {
      active = false;
    };
  }, []);

  useEffect(() => {
    const tabUrl = new URLSearchParams(search).get('tab')?.toLowerCase();
    if (!tabUrl) return;
    if (tabUrl === TAB_PLAN) {
      history.replace(ROUTE_PLANS_PRIVATE.path);
      return;
    }
    if (tabUrl === TAB_INVOICES) {
      setActiveTab(hasInvoices ? TAB_INVOICES : TAB_BILLING);
      return;
    }
    if (tabUrl === TAB_BILLING) {
      setActiveTab(TAB_BILLING);
    }
  }, [search, hasInvoices]);

  return (
    <SpacingContainerBase>
      <Typography weight="700" variant="h2" gutter="bottomSpace">
        {trans('billing-overview')}
      </Typography>

      <Grid container>
        <Grid item>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs
              indicatorColor="primary"
              TabIndicatorProps={{
                style: {
                  height: '3px',
                },
              }}
              className={styles.tabsContainer}
              value={activeTab}
              onChange={handleChange}
              aria-label="tab"
            >
              <Tab
                value={TAB_BILLING}
                className={clsx(styles.tab, activeTab === TAB_BILLING && styles.activeTab)}
                label={trans('billing')}
                {...a11yProps(TAB_BILLING)}
              />
              {hasInvoices && (
                <Tab
                  value={TAB_INVOICES}
                  className={clsx(styles.tab, styles.borderLeftRight, activeTab === TAB_INVOICES && styles.activeTab)}
                  label={trans('invoices')}
                  {...a11yProps(TAB_INVOICES)}
                />
              )}
              <Tab value={TAB_PLAN} className={clsx(styles.tab)} label={trans('plan')} {...a11yProps(TAB_PLAN)} />
            </Tabs>
          </Box>
        </Grid>
      </Grid>

      <TabPanel value={activeTab} index={TAB_BILLING}>
        <BillingTab navigateManagePlan={handleChange} />
      </TabPanel>
      {hasInvoices && (
        <TabPanel value={activeTab} index={TAB_INVOICES}>
          <InvoicesTab />
        </TabPanel>
      )}
    </SpacingContainerBase>
  );
};

export default connect(Billing);
